import { models } from '@kurtosys/ksys-app-template';
export const AUTHENTICATION: models.appsInitialize.IAppAuthentication = {
	// Locally we make use of the proxy to get the app to run.
	// token: '',
	// serviceUrl: 'https://api-local.fundpress.io',
};